// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { colors, transition } from '../theme';

const ToggleInput = styled(({ className, ...props }) => (
  <Box className={className}>
    <input type="checkbox" {...props} />
  </Box>
))`
  position: relative;
  border-radius: 12px;
  height: 24px;
  width: 40px;
  transition: all ${transition};
  &::before {
    content: '\\2713';
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: white;
    font-size: 14px;
    transition: all ${transition};
  }
  input {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  ${props =>
    props.value
      ? `
    background: ${colors.waterBlue};
    &::before { 
      transform: translateX(16px) translateY(-50%);
      color: ${colors.waterBlue};
    }
  `
      : `
    background: ${colors.aluminum};
    &::before { 
      color: white;
    }
  `};
`;

export default ToggleInput;
